const columnShape = [
    {
        Header: "No",
        maxWidth:20,
        accessor: (_, index) => index + 1,
    },
    {
        Header: "Invoice Number",
        accessor: "number"
    }, 
    {
        Header: "Full Name",
        accessor: "user.fullName"
    }, 
    {
        Header: "Nik",
        accessor: "user.nik"
    }, 
    {
        Header: "Profession",
        accessor: "user.profession"
    }, 
    {
        Header: "Phone Number",
        accessor: "user.phoneNumber"
    }, 
    {
        Header: "Email",
        accessor: "user.email"
    }, 
    {
        Header: "Istitution",
        accessor: "user.institution"
    }, 
];
export default columnShape;
